import client from '@/services/graphql/client';
import { stytch } from '.';

export const signOut = async () => {
    await stytch.session.revoke();
    await client.clearStore();
};
